import { jsx as _jsx, jsxs as _jsxs } from "@emotion/react/jsx-runtime";
import { Grid, Typography, Box } from '@mui/material';
import { InfoOutlined } from '@mui/icons-material';
import { useTranslation } from 'react-i18next';
/**
 * Infobase Subtitle Component
 * @param props InfobaseSubtitle's Props
 * @returns JSX Element
*/
export function InfobaseSubtitle(props) {
    const { text } = props;
    let { styles } = props;
    if (!styles) {
        styles = {};
    }
    const { /** Translation function */ t } = useTranslation();
    return (_jsx(Box, Object.assign({ sx: Object.assign({ padding: '1rem', backgroundColor: 'greenLight.main', borderRadius: '0.75rem' }, styles) }, { children: _jsxs(Grid, Object.assign({ container: true, spacing: 1 }, { children: [_jsx(Grid, Object.assign({ item: true, sx: { display: 'flex', alignItems: 'center' } }, { children: _jsx(InfoOutlined, { sx: { color: 'blackLight.main' } }) })), _jsx(Grid, Object.assign({ item: true, xs: true }, { children: _jsx(Typography, { children: t(text) }) }))] })) })));
}
;
